import styled from 'styled-components';

export const ModalWrapper = styled.div`
  width: 83vw;
  max-width: 20rem;

  > div {
    float: right;
  }
`;

export const ModalContent = styled.div`
  display:flex;
  flex-direction: column;
  gap: 24px;
  padding: 1.5rem 0.5rem 3rem 0.5rem;

  form {
    display:flex;
    flex-direction: column;
    gap: 24px;

    > label p {
      font-family: "Crimson Text";
      font-size: 14px;
      letter-spacing: normal;
      text-transform: none;
    }

    input {
      font-family: "Crimson Text";
      font-size: 16px;
      padding-left: 1rem;
      padding-right: 1rem;
    }
    
    button {
      text-transform: uppercase;
    }

    button:last-child {
      text-align: center;
      font-family: Lato;
      font-size: 12px;
      font-weight: 600;
      line-height: 150%;
      letter-spacing: 1px;
      margin-bottom: 12px;
    }
`;

export const ModalText = styled.div`
  > h5 {
    font-family: "Crimson Text";
    font-size: 24px;
    font-weight: 400;
    margin: 0;
    margin-bottom: 0.5rem;
  }

  > p {
    font-family: "Crimson Text";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    margin: 0;
  }
`;
